import React from "react";
import { IPrimaryUser } from "services/api/api.types";

import {
  PaidUserMobileDivider,
  PaidUserMobileFeatureBlockCTA,
  PaidUserMobileFeatureBlockDetails,
  PaidUserMobileFeatureBlockHeading,
  PaidUserMobileFeatureBlockImage,
  PaidUserMobileFeatureBlockImageWrapper,
  PaidUserMobileFeatureBlockLink,
  PaidUserMobileHeading,
  PaidUserMobileSection,
  PaidUserMobileUserNotice,
  PaidUserMobileUserNoticeMessage,
  PaidUserMobileUserNoticeMessageHeading1,
  PaidUserMobileUserNoticeMessageHeading2,
  PaiUserMobileFeatureBlock
} from "./paid-user-mobile.styles";
import Image from "next/legacy/image";
import LiveClassMockup from "public/assets/kelas-live/live-classes-web-mobile.png";
import { Container } from "styles/common/container";
import { Spacer } from "styles/common/spacer";

const PaidUserMobile: React.FC<{ primaryUser: IPrimaryUser }> = ({
  primaryUser
}) => {
  return (
    <>
      <PaidUserMobileUserNotice>
        <PaidUserMobileUserNoticeMessageHeading1>
          Hai, {primaryUser.full_name}!
        </PaidUserMobileUserNoticeMessageHeading1>
        <PaidUserMobileUserNoticeMessageHeading2>
          Kamu sekarang langganan Paket Juara 😊
        </PaidUserMobileUserNoticeMessageHeading2>
        <PaidUserMobileUserNoticeMessage>
          Semangat ngambis di kelasnya, ya!
        </PaidUserMobileUserNoticeMessage>
      </PaidUserMobileUserNotice>
      <PaidUserMobileSection>
        <Image
          src={LiveClassMockup}
          alt="Live Classes on app and laptop"
          layout="intrinsic"
        />
        <Container>
          <PaidUserMobileHeading>
            Bisa ikut Kelas Live lewat aplikasi CoLearn atau website di laptop
          </PaidUserMobileHeading>
          <Spacer token={[24, 24, 24]} />
          <PaiUserMobileFeatureBlock>
            <PaidUserMobileFeatureBlockImageWrapper>
              <PaidUserMobileFeatureBlockImage
                src="/assets/kelas-live/colearn-laptop.svg"
                alt="Colearn on laptop"
              />
            </PaidUserMobileFeatureBlockImageWrapper>
            <PaidUserMobileFeatureBlockDetails>
              <PaidUserMobileFeatureBlockHeading>
                Masuk ke website Kelas Live di laptop
              </PaidUserMobileFeatureBlockHeading>
              <PaidUserMobileFeatureBlockLink>
                colearn.id/bimbel
              </PaidUserMobileFeatureBlockLink>
            </PaidUserMobileFeatureBlockDetails>
          </PaiUserMobileFeatureBlock>
          <Spacer token={[24, 24, 24]} />
          <PaidUserMobileDivider>atau</PaidUserMobileDivider>
          <Spacer token={[24, 24, 24]} />
          <PaiUserMobileFeatureBlock>
            <PaidUserMobileFeatureBlockImageWrapper>
              <PaidUserMobileFeatureBlockImage
                src="/assets/kelas-live/colearn-mobile.svg"
                alt="Colearn on mobile"
              />
            </PaidUserMobileFeatureBlockImageWrapper>
            <PaidUserMobileFeatureBlockDetails>
              <PaidUserMobileFeatureBlockHeading>
                Masuk ke Kelas Live di aplikasi CoLearn
              </PaidUserMobileFeatureBlockHeading>
              <PaidUserMobileFeatureBlockCTA href="https://colearn.app.link/DownloadCoLearn">
                Download Colearn
              </PaidUserMobileFeatureBlockCTA>
            </PaidUserMobileFeatureBlockDetails>
          </PaiUserMobileFeatureBlock>
          <Spacer token={[24, 24, 24]} />
        </Container>
      </PaidUserMobileSection>
    </>
  );
};

export { PaidUserMobile };
